import Typography from 'antd/lib/typography';
import './informationCard.css';
import Tooltip from 'antd/lib/tooltip';
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import React from 'react';

interface IInformationCardTitle {
    icon?: React.ReactNode;
    classNames?: string[];
    title: string;
    tooltip?: string;
}

export const InformationCardTitle = ({ icon, title, classNames = [], tooltip }: IInformationCardTitle) => (
    <Typography.Text className={`information-card-title ${classNames?.join(' ')}`}>
        {icon && icon}&nbsp;{title}
        {tooltip && (
            <>
                &nbsp;
                <Tooltip title={tooltip}>
                    <QuestionCircleOutlined />
                </Tooltip>{' '}
            </>
        )}
    </Typography.Text>
);
